import { normalizePathTrailingSlash } from 'next/dist/client/normalize-trailing-slash';
import { addBasePath } from 'next/dist/client/add-base-path';
import { serialize, stringify, deserialize } from 'superjson';
import { isServer } from 'blitz';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function normalizeApiRoute(path) {
  return normalizePathTrailingSlash(addBasePath(path));
}
function __internal_buildRpcClient({
  resolverName,
  resolverType,
  routePath,
  httpMethod
}) {
  const fullRoutePath = normalizeApiRoute("/api/rpc" + routePath);
  const routePathURL = new URL(fullRoutePath, window.location.origin);
  const httpClient = (_0, ..._1) => __async(this, [_0, ..._1], function* (params, opts = {}, signal = void 0) {
    const debug = (yield import('debug')).default("blitz:rpc");
    if (!opts.fromQueryHook && !opts.fromInvoke) {
      console.warn(
        "[Deprecation] Directly calling queries/mutations is deprecated in favor of invoke(queryFn, params)"
      );
    }
    if (isServer) {
      return Promise.resolve();
    }
    debug("Starting request for", fullRoutePath, "with", params, "and", opts);
    let serialized;
    if (opts.alreadySerialized) {
      serialized = params;
    } else {
      serialized = serialize(params);
    }
    if (httpMethod === "GET" && serialized.json) {
      routePathURL.searchParams.set("params", stringify(serialized.json));
      routePathURL.searchParams.set("meta", stringify(serialized.meta));
    }
    const { beforeHttpRequest, beforeHttpResponse } = globalThis.__BLITZ_MIDDLEWARE_HOOKS;
    const promise = window.fetch(
      routePathURL,
      beforeHttpRequest({
        method: httpMethod,
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        redirect: "follow",
        body: httpMethod === "POST" ? JSON.stringify({
          params: serialized.json,
          meta: {
            params: serialized.meta
          }
        }) : void 0,
        signal
      })
    ).then((response) => __async(this, null, function* () {
      var _a, _b;
      debug("Received request for", routePath);
      response = beforeHttpResponse(response);
      if (!response.ok) {
        const error = new Error(response.statusText);
        error.statusCode = response.status;
        error.path = routePath;
        error.stack = null;
        throw error;
      } else {
        let payload;
        try {
          payload = yield response.json();
        } catch (error) {
          const err = new Error(`Failed to parse json from ${routePath}`);
          err.stack = null;
          throw err;
        }
        if (payload.error) {
          let error = deserialize({
            json: payload.error,
            meta: (_a = payload.meta) == null ? void 0 : _a.error
          });
          const rpcEvent = new CustomEvent("blitz:rpc-error", {
            detail: error
          });
          document.dispatchEvent(rpcEvent);
          const prismaError = error.message.match(/invalid.*prisma.*invocation/i);
          if (prismaError && !("code" in error)) {
            error = new Error(prismaError[0]);
            error.statusCode = 500;
          }
          error.stack = null;
          throw error;
        } else {
          const data = deserialize({
            json: payload.result,
            meta: (_b = payload.meta) == null ? void 0 : _b.result
          });
          if (!opts.fromQueryHook) {
            const { getQueryKeyFromUrlAndParams } = yield import('./utils.mjs');
            const queryKey = getQueryKeyFromUrlAndParams(routePath, params);
            globalThis.queryClient.setQueryData(queryKey, data);
          }
          return data;
        }
      }
    }));
    return promise;
  });
  const rpcClient = httpClient;
  rpcClient._isRpcClient = true;
  rpcClient._resolverName = resolverName;
  rpcClient._resolverType = resolverType;
  rpcClient._routePath = fullRoutePath;
  return rpcClient;
}

export { __internal_buildRpcClient as _, normalizeApiRoute as n };
